import { Field } from '../../../concepts/objects';
import { Rect, RectLike } from '../../../platform/geom/Rect';

export class FieldLayout extends Rect {

    public readonly rounding: number;

    constructor(rect: RectLike, rounding: number);
    constructor(left: number, top: number, width: number, height: number, rounding: number);
    constructor(...args: any[]) {
        const [left, top, width, height] = args.length === 2 ? args[0].toArray() : args;
        super(left, top, width, height);
        this.rounding = args[args.length - 1];
    }
}

export abstract class AdaptableField extends Field {

    public get default() {
        return false;
    }

    public abstract get layout(): FieldLayout;

    public get bounds(): Rect {
        return this.layout;
    }
}
